import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import performanceService from "../../services/performance.service";
import { getAccountScanPermissions } from "store/slices/scanPermissionsSlice";

export const pingTest = createAsyncThunk("performanceTest/pingTest", async (data, {
    rejectWithValue, dispatch
}) => {
    try {
        const response = await performanceService.pingTest(data);
        if (response.status === 200) {
            dispatch(getAccountScanPermissions());
        }
        return response;
    } catch (error) {
        return rejectWithValue(error);
    }
});

export const LoadTimeTest = createAsyncThunk("performanceTest/loadTest", async (data, {
    rejectWithValue, dispatch
}) => {
    try {
        const response = await performanceService.LoadTimeTest(data);
        if (response.status === 200) {
            dispatch(getAccountScanPermissions());
        }
        return response;
    } catch (error) {
        return rejectWithValue(error);
    }
});

export const sslAnalyze = createAsyncThunk("performanceTest/sslAnalyze", async (data, {
    rejectWithValue, dispatch
}) => {
    try {
        const response = await performanceService.sslAnalyze(data);
        if (response.status === 200) {
            dispatch(getAccountScanPermissions());
        }
        return response;
    } catch (error) {
        return rejectWithValue(error);
    }
});

export const getDomainsWithReadySSLAnalyze = createAsyncThunk(
    "sslAnalyze/getDomainsWithReadySSLAnalyze",
    async (_, { rejectWithValue }) => {
        try {
            const response = await performanceService.getDomainsWithReadySSLAnalyze();
            return response.data;
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);

export const getSslAnalyze = createAsyncThunk(
    "performanceTest/getSslAnalyze",
    async (data, { rejectWithValue }) => {
        try {
            return await performanceService.getSslAnalyze(data);
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);

export const getPingTestResult = createAsyncThunk("performanceTest/getPingTestResult", async (domainId, {
    rejectWithValue
}) => {
    try {
        return await performanceService.getPingTestResult(domainId);
    } catch (error) {
        return rejectWithValue(error);
    }
});

export const getLoadTimeTestResult = createAsyncThunk("performanceTest/getLoadTimeTestResult", async (data, {
    rejectWithValue
}) => {
    try {
        return await performanceService.getLoadTimeTestResult(data);
    } catch (error) {
        return rejectWithValue(error);
    }
});

export const getDomainsWithPerformanceTest = createAsyncThunk("performanceTest/getDomainsWithPerformanceTest", async (data, {
    rejectWithValue
}) => {
    try {
        return await performanceService.getDomainsWithPerformanceTest(data?.data);
    } catch (error) {
        return rejectWithValue(error);
    }
});

const initialState = {
    performancePingTest: [],
    performanceLoadTimeTest: [],
    performancegetPingTestResult: [],
    performanceTestError: false,
    getSslAnalysis: [],
    sslAnalysisResult: null,
    performancegetLoadTimeTestResult: [],
    tableLoading: false,
    testSelectedDomain: null,
    domainsWithPerformanceTests: [],
    domainLoading: false,
    sslTestLoading: false,
    pingTestLoading: false,
    pingTestError: false,
    sslTestError: false,
    loadTimeTestLoading: false,
    domainsWithReadySSLAnalyze: [],
    sslAnalyzeLoading: false,
    sslAnalyzeError: false,
    errorMessage: null,
    successMessage: null,
};

export const performanceSlice = createSlice({
    name: 'performanceSlice',
    initialState,
    reducers: {
        clearPerformanceData: (state, action) => {
            state.performancegetPingTestResult = [];
            state.performancegetLoadTimeTestResult = [];
            state.getSslAnalysis = [];
            state.domainsWithReadySSLAnalyze = [];
        },
        setSslAnalysisResult: (state, action) => {
            state.sslAnalysisResult = action.payload
        },
        setSelectedDomain: (state, action) => {
            state.testSelectedDomain = action.payload;
        },
        resetErrorMessages: (state) => {
            state.errorMessage = null;
            state.successMessage = null;
        },
        resetPingTestError: (state) => {
            state.pingTestError = false;
        },
        resetSslTestError: (state) => {
            state.sslTestError = false;
        },
        resetPerformanceTestError: (state) => {
            state.performanceTestError = false;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(pingTest.fulfilled, (state, action) => {
            state.pingTestLoading = false;
            if (action.payload?.response?.data?.error || !action.payload) {
                state.pingTestError = action.payload?.response?.data?.error || 'error';
            } else {
                state.performancePingTest = action.payload.data;
                state.successMessage = 'success';
                state.pingTestError = false;
            }
        });

        builder.addCase(pingTest.pending, (state, action) => {
            state.pingTestLoading = true;
            state.pingTestError = false;
        });

        builder.addCase(pingTest.rejected, (state, action) => {
            state.pingTestLoading = false;
            state.pingTestError = action.payload?.response?.data?.error;
        });

        builder.addCase(LoadTimeTest.fulfilled, (state, action) => {
            state.loadTimeTestLoading = false;

            if (action.payload?.response?.data?.error || !action.payload) {
                state.performanceTestError = action.payload?.response?.data?.error || 'error';
            } else {
                state.performanceLoadTimeTest = action.payload.data;
                state.successMessage = 'success';
                state.performanceTestError = false;
            }
        });

        builder.addCase(LoadTimeTest.pending, (state, action) => {
            state.loadTimeTestLoading = true;
            state.performanceTestError = false;
        });

        builder.addCase(LoadTimeTest.rejected, (state, action) => {
            state.loadTimeTestLoading = false;
            state.performanceTestError = action.payload?.response?.data?.error || 'error';
        });
        builder.addCase(sslAnalyze.fulfilled, (state, action) => {
            state.sslTestLoading = false;

            if (action.payload?.response?.data?.error || !action.payload) {
                state.sslTestError = action.payload?.response?.data?.error || 'error';
            } else {
                state.successMessage = 'success';
            }
        });

        builder.addCase(sslAnalyze.pending, (state, action) => {
            state.sslTestLoading = true;
        });

        builder.addCase(sslAnalyze.rejected, (state, action) => {
            state.sslTestLoading = false;
            state.testSelectedDomain = null;
            state.sslTestError = action.payload?.response?.data?.error || 'error';
        });
        builder.addCase(getSslAnalyze.fulfilled, (state, action) => {
            state.getSslAnalysis = {
                ...action?.payload?.data,
                content: action?.payload?.data?.content?.filter(item => item?.status === "READY")
            };
            state.tableLoading = false;
        });

        builder.addCase(getSslAnalyze.pending, (state, action) => {
            state.tableLoading = true;
        });

        builder.addCase(getSslAnalyze.rejected, (state, action) => {
            state.tableLoading = false;

        });
        builder.addCase(getPingTestResult.fulfilled, (state, action) => {
            state.performancegetPingTestResult = action.payload.data;
            state.tableLoading = false;
        });

        builder.addCase(getPingTestResult.pending, (state, action) => {
            state.tableLoading = true;
        });

        builder.addCase(getPingTestResult.rejected, (state, action) => {
            state.tableLoading = false;
        });
        builder.addCase(getLoadTimeTestResult.fulfilled, (state, action) => {
            state.performancegetLoadTimeTestResult = action.payload.data;
            state.tableLoading = false;
        });

        builder.addCase(getLoadTimeTestResult.pending, (state, action) => {
            state.tableLoading = true;
        });

        builder.addCase(getLoadTimeTestResult.rejected, (state, action) => {
            state.tableLoading = false;
        });
        builder.addCase(getDomainsWithPerformanceTest.fulfilled, (state, action) => {
            state.domainsWithPerformanceTests = action.payload.data;
            state.domainLoading = false;
        });
        builder.addCase(getDomainsWithPerformanceTest.pending, (state, action) => {
            state.domainLoading = true;
        });
        builder.addCase(getDomainsWithPerformanceTest.rejected, (state, action) => {
            state.domainLoading = false;
        });

        builder.addCase(getDomainsWithReadySSLAnalyze.fulfilled, (state, action) => {
            if (action?.payload?.response?.status === 500 || action?.payload?.response?.status === 404 || action?.payload === undefined) {
                state.sslAnalyzeError = true;
                state.sslAnalyzeLoading = false;
            } else {
                state.domainsWithReadySSLAnalyze = action?.payload;
                state.sslAnalyzeLoading = false;
                state.sslAnalyzeError = false;
            }
        });
        builder.addCase(getDomainsWithReadySSLAnalyze.pending, (state, action) => {
            state.sslAnalyzeLoading = true;
        });

        builder.addCase(getDomainsWithReadySSLAnalyze.rejected, (state, action) => {
            state.sslAnalyzeLoading = false;
        });
    }
});

export const {
    clearPerformanceData,
    setSslAnalysisResult,
    setSelectedDomain,
    resetErrorMessages,
    resetPingTestError,
    resetSslTestError,
    resetPerformanceTestError
} = performanceSlice.actions;

export default performanceSlice.reducer;

